import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.VRR2P3PQ.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-search-overlay/jb-search-overlay.scss?inline
var jb_search_overlay_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

section {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--row-small-margin, 6.68%));
  justify-content: center;
}
@media (min-width: 600px) and (max-width: 959px) {
  section {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  section {
    max-width: var(--row-max-width, 1436px);
  }
  section:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  section {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}

form {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 0;
  width: 100%;
  margin-block: 67px;
}
@media (min-width: 600px) {
  form {
    margin-block: 187px;
    padding-inline: 26px 23px;
  }
}
@media (min-width: 960px) {
  form {
    box-sizing: border-box;
    flex-basis: 50%;
    max-width: 50%;
    padding: 0 20px;
    width: 50%;
    padding-inline: 52px;
  }
}
@media (min-width: 1281px) {
  form {
    margin-block: 177px;
  }
}

jb-search-input {
  --fill-color: white;
  --secondary-color: rgba(255, 255, 255, 1);
  --stroke-color: rgba(255, 255, 255, 0.4);
  opacity: 0;
}
@media (min-width: 960px) {
  jb-search-input {
    --search-icon-translate: -4px;
  }
}

:host {
  background-color: #141e55;
  display: block;
  height: 100%;
  transform-origin: top center;
  width: 100%;
}`;

// src/components/jb-search-overlay/jb-search-overlay.ts
var JbSearchOverlay = class extends Initiable(Animatable(h)) {
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("formAction") && this.formAction && this._form) {
      const formActionUrl = new URL(this.formAction);
      formActionUrl.searchParams.forEach((value, key) => {
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", key);
        input.setAttribute("value", value);
        this._form?.append(input);
      });
    }
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    setTimeout(() => {
      this._searchInput?.focusSearchInput();
    }, 0);
  }
  _submit(event) {
    if (this._queryInput) {
      this._queryInput.value = event.detail.value;
    }
    this._form?.submit();
  }
  render() {
    const formActionUrl = new URL(this.formAction, document.baseURI);
    const action = `${formActionUrl.protocol}//${formActionUrl.host}${formActionUrl.pathname ? `${formActionUrl.pathname}` : ""}${formActionUrl.port ? `:${formActionUrl.port}` : ""} `;
    return ke`
      <section>
        <form
          method="get"
          action="${action}"
        >
          <input
            id="queryInput"
            type="hidden"
            name="${this.queryParameter}"
            value=""
          />
          <jb-search-input
            class="in-search-overlay"
            @jb-search-input:submit=${this._submit}
            .autoSuggestUrl=${this.searchInput.autoSuggestUrl}
            .placeholder=${this.searchInput.placeholder}
            .suggestMode=${this.searchInput.suggestMode}
          ></jb-search-input>
        </form>
      </section>
    `;
  }
};
JbSearchOverlay.styles = r(jb_search_overlay_default);
__decorateClass([
  n()
], JbSearchOverlay.prototype, "formAction", 2);
__decorateClass([
  n()
], JbSearchOverlay.prototype, "queryParameter", 2);
__decorateClass([
  n({ type: Object })
], JbSearchOverlay.prototype, "searchInput", 2);
__decorateClass([
  e("form")
], JbSearchOverlay.prototype, "_form", 2);
__decorateClass([
  e("#queryInput")
], JbSearchOverlay.prototype, "_queryInput", 2);
__decorateClass([
  e("jb-search-input")
], JbSearchOverlay.prototype, "_searchInput", 2);
JbSearchOverlay = __decorateClass([
  customElement("jb-search-overlay")
], JbSearchOverlay);

export {
  JbSearchOverlay
};
